import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courier',
  templateUrl: './courier.component.html',
  styleUrls: ['./courier.component.css']
})
export class CourierComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
